
import * as CryptoJS from 'crypto-js';

export function encryptParam(str: string) {
    const key = '8q7f15a4oc212ef3';
    const iv = '8q7f15a4oc212ef3';
    const keyWordArray = CryptoJS.enc.Utf8.parse(key)
    const ivWordArray = CryptoJS.enc.Utf8.parse(iv)
    const data = CryptoJS.enc.Utf8.parse(str)
    const options = {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }
    const encrypted = CryptoJS.AES.encrypt(data, keyWordArray, {
        ...options,
        iv: ivWordArray
    })
    return encodeURIComponent(encrypted.toString())
}

export function decryptParam(str: string) {
    const key = '8q7f15a4oc212ef3';
    const iv = '8q7f15a4oc212ef3';
    const keyWordArray = CryptoJS.enc.Utf8.parse(key)
    const ivWordArray = CryptoJS.enc.Utf8.parse(iv)
    const decrypted = CryptoJS.AES.decrypt(decodeURIComponent(str), keyWordArray, {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv: ivWordArray
    })

    return decrypted.toString(CryptoJS.enc.Utf8)
}